"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n"], ["\n    width: 100%;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Menu = _styledComponents2.default.ul(_templateObject);

exports.default = Menu;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/menu/menu.js
// module id = 1012
// module chunks = 95715928098905 168707334958949